import { TypographyComponent } from '@bybeam/platform-types';
import Markdown from '@platform-ui-common/components/Markdown/index.js';
import { GenericFormData } from '@platform-ui-common/hooks/useForm/index.js';
import { FieldContext } from '@platform-ui/utilities/application/fields/index.js';
import cx from 'classnames';
import { FieldProps } from './types.js';

export default function TextContentField<FormData extends GenericFormData>({
  field: { props, copy },
  setValidationOverrides: _,
  context,
}: FieldProps<TypographyComponent, FormData>): JSX.Element {
  return (
    <div
      className={cx(
        'flex flex-col gap-4 mt-2 text-center lg:text-left',
        context === FieldContext.Panel ? 'w-full' : 'w-field',
      )}
    >
      <Markdown {...props}>{copy}</Markdown>
    </div>
  );
}
